import { useEffect } from 'react';

export const ScrollToTop = () => {
  useEffect(() => {
    const handleTitleFinalized = () => {
      window.scrollTo(0, 0);
    };

    // Listen for the custom "titleFinalized" event
    window.addEventListener('titleFinalized', handleTitleFinalized);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('titleFinalized', handleTitleFinalized);
    };
  }, []);

  return null;
};
